// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body {\n  margin: 0px; }\n\n.App {\n  width: 100vw;\n  height: 100vh; }\n", "",{"version":3,"sources":["webpack://src/styles/App.scss"],"names":[],"mappings":"AAAA;EACE,WAAW,EAAA;;AAEb;EACE,YAAY;EACZ,aAAa,EAAA","sourcesContent":["body{\n  margin: 0px;\n}\n.App {\n  width: 100vw;\n  height: 100vh;\n  \n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
